export const initialStore = {
  dataResults: [],
  queryStore: '',
  firstRender: true,
  page: 1,
  isQueryLoading: false,
  //
  name: '',
  brand: '',
  brandManufacturer: '',
  GTIN: '',
  SKUS: '',
  taxonomyLevel1: '',
  taxonomyLevel2: '',
  taxonomyLevel3: '',
  primaryCategories: ['Any'],
  rawCategory: '',
  categoryWildCard: '',
  categoriesWithParenthesis: '',
  rentalPrice: {
    minValue: '',
    maxValue: '',
    currency: ''
  },
  mostRecentPriceDate: {
    startDate: '',
    endDate: ''
  },
  description: {
    value: ''
  },
  reviewsRangeQuery: {
    // New field for reviews range
    min: '',
    max: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  featureKeyword: {
    key: '',
    value: ''
  },
  requiredFields: [],
  domain: '',
  mostRecentPriceIsSale: '',
  taxonomy: '',
  price: {
    minValue: '',
    maxValue: '',
    currency: ''
  },
  priceWarranty: '',
  color: '',
  featuresWithKey: '',
  manufacturerNumber: '',
}
